import { info } from '../../services/sentryLogger'
import { downloadCSV, jsonListToCSV } from '../../utils'
import { SessionData } from './types'

const SESSION_DATA = 'SESSION_DATA'
// FIXME deprecated used by saveLocalSession - no horodatage !
export const saveLocalSession = (value: SessionData) =>
    localStorage.setItem(SESSION_DATA, JSON.stringify(value))

export const loadLocalSession: () => SessionData | null = () => {
    const data = localStorage.getItem(SESSION_DATA)
    const parsed = data ? (JSON.parse(data) as SessionData) : null
    return parsed
}

export const resetSession = () => localStorage.removeItem(SESSION_DATA)

export const downloadSession = (sessionData: SessionData) => {
    // TXT OK ...
    // const text = JSON.stringify(sessionData, null, 2);
    // downloadTXT('session.txt', text)

    // CSVs
    const fieldsWithList: string[] = [
        'round1',
        'round1Result', //TODO broken
        'round2',
        'round2Result',
        'round3',
        'round3Result',
        'bucketRound',
        'finalResult',
    ]
    info('downloadSession', sessionData)
    fieldsWithList.forEach((field: string) => {
        // @ts-ignore
        const csv = jsonListToCSV(sessionData[field])
        downloadCSV(`${field}.csv`, csv)
    })

    // const flattenedKeyValue = flattenProperties(sessionData);
    // const csv = jsonListToCSV([flattenedKeyValue]);
}
